import * as z from "zod/v4";

export const setMerchantFraudFeedback = {
  name: "setMerchantFraudFeedback" as const,
  input: z.object({
    returnId: z.string(),
    isFraud: z.boolean(),
    feedback: z.string().optional(),
  }),
  output: z.null(),
};
